import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'session',
    pathMatch: 'full'
  },
  {
    path: 'ticket/book',
    redirectTo: 'session',
    pathMatch: 'full'
  },
  {
    path: 'session',
    loadComponent: () => import('./views/session-list/session-list.component').then(m => m.SessionListComponent)
  },
  {
    path: 'booking/:locationId',
    loadComponent: () => import('./views/booking-detail/booking-detail.component').then(m => m.BookingDetailComponent)
  },
  {
    path: 'order/:locationId',
    loadComponent: () => import('./views/order-detail/order-detail.component').then(m => m.OrderDetailComponent)
  }
];
